import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { addEpisode, deleteShow, editShow, fetchTvShows } from '../actions';
import { selectActiveShow } from '../selectors';

import Icon from '../../common/icons/Icon';
import TvEpisodeList from '../episodes/TvEpisodeList';
import TvShowEditForm from './TvShowEditForm';
import AddForm from '../../common/forms/AddForm';
import Breadcrumb from '../../common/components/Breadcrumb';
import dataUrlToFile from '../../common/utils/dataUrlToFile';
import Loading from '../../common/components/Loading';

class TvShowEditPage extends Component {
  static propTypes = {
    activeShow: PropTypes.object,
    dispatch: PropTypes.func,
    initialValues: PropTypes.object,
    shows: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addEpisodeModalVisible: false,
      clearOrigImage: false,
      editing: false,
    };
  }

  componentDidMount() {
    if (!this.props.shows.get('loaded') && !this.props.shows.get('loading')) {
      this.props.dispatch(fetchTvShows());
    }
  }

  toggleEdit = () => {
    this.setState(state => ({
      editing: !state.editing,
      clearOrigImage: false,
    }));
  };

  toggleAddEpisodeModal = () => {
    this.setState(state => ({ addEpisodeModalVisible: !state.addEpisodeModalVisible }));
  };

  onEditShowSubmit = values => {
    const { dispatch, match: { params: { id } }, activeShow } = this.props;
    const { clearOrigImage } = this.state;

    if (values.image) {
      values.image = dataUrlToFile(values.image.imageResult, values.image.imageFilename);
    }

    if (!clearOrigImage) {
      values.image_id = activeShow.get('image_id');
    }

    return dispatch(editShow(id, values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState(state => ({ editing: false }));
      }
    });
  };

  onAddEpisodeSubmit = values => {
    const { activeShow, dispatch } = this.props;

    return dispatch(addEpisode(activeShow.get('id'), values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(`/tv/shows/${activeShow.get('id')}/episodes/${action.json.id}`);
      }
    });
  };

  onDelete = () => {
    const { dispatch, match: { params: { id } } } = this.props;

    return dispatch(deleteShow(id)).then(() => {
      this.props.history.push('/tv/shows');
    });
  };

  removeImage = () => {
    this.setState(state => ({ clearOrigImage: true }));
  };

  render() {
    const { activeShow, initialValues, shows } = this.props;
    const { addEpisodeModalVisible, clearOrigImage, editing } = this.state;

    if (!shows.get('loaded') || !activeShow) {
      return <Loading />;
    }

    const breadcrumbs = [
      {
        label: 'Tathata TV',
        to: '/tv/shows',
      },
      {
        label: activeShow.get('name'),
        to: null,
      },
    ];

    return (
      <div className="admin-paper">
        <Modal isVisible={addEpisodeModalVisible} onClose={this.toggleAddEpisodeModal}>
          <AddForm
            entityType="Episode"
            initialValues={{ name: null }}
            onSubmit={this.onAddEpisodeSubmit}
            onCancel={this.toggleAddEpisodeModal}
          />
        </Modal>
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
          <button onClick={this.toggleAddEpisodeModal} className="admin__add-button">
            <Icon icon="Plus" /> Add Episode
          </button>
        </div>
        {editing ? (
          <TvShowEditForm
            clearOrigImage={clearOrigImage}
            initialValues={initialValues}
            onSubmit={this.onEditShowSubmit}
            onCancel={this.toggleEdit}
            onDelete={this.onDelete}
            removeImage={this.removeImage}
            show={activeShow}
          />
        ) : (
          <div>
            <div className="admin-paper__edit-content" key="show-info">
              <div className="admin-paper__edit-content__row">
                <p>Show Name</p>
                <span className="title">{activeShow.get('name')}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Show Description</p>
                <span>{activeShow.get('description') ? activeShow.get('description') : <em>No Description</em>}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <div className="admin-paper__edit-content__upload">
                  <p>Show Image</p>
                  {activeShow.getIn(['image', 'location']) ? (
                    <div
                      className="admin__image-preview"
                      style={{ backgroundImage: `url(${activeShow.getIn(['image', 'location'])})` }}
                    />
                  ) : (
                    <div className="admin__image__placeholder image__placeholder">No Image</div>
                  )}
                </div>
              </div>
              <div className="admin-paper__edit-button">
                <button className="button" onClick={this.toggleEdit}>
                  Edit
                </button>
              </div>
            </div>
            <TvEpisodeList showId={activeShow.get('id')} />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeShow = selectActiveShow(state, ownProps.match.params.id);

  return {
    activeShow,
    initialValues: activeShow ? { name: activeShow.get('name'), description: activeShow.get('description') } : null,
    shows: state.tv.shows,
  };
})(TvShowEditPage);



// WEBPACK FOOTER //
// ./src/tv/shows/TvShowEditPage.js